import { render, staticRenderFns } from "./ExportDetail.vue?vue&type=template&id=5c57aa6d&scoped=true"
import script from "./ExportDetail.vue?vue&type=script&lang=js"
export * from "./ExportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57aa6d",
  null
  
)

export default component.exports